import { useQuery } from '@tanstack/react-query'

import { GetPageComponentItemViewModel } from '@/types/cml-api'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query/query-keys'

export const fetchGoodbyeSummerRequest = async (isServerSideRequest: boolean) =>
    fetchRequest({
        endpoint: '/cases/goodbye-summer',
        method: 'GET',
        serviceName: 'cml',
        isServerSideRequest,
    })

export const useFetchGoodbyeSummerData = () => {
    const { data, isLoading, isError } = useQuery<GetPageComponentItemViewModel[]>({
        queryKey: QueryKeys.GoodbyeSummerLanding.Data,
        queryFn: () => fetchGoodbyeSummerRequest(false),
        refetchOnMount: false,
    })

    return { data, isLoading, isError }
}
